import { useSelector } from "react-redux";


const FlipkartStockSync = () => {
  const OrgId = useSelector((state) => state.auth.org_id)
  // console.log(OrgId, 'org_id__________')
  
  return (
    <div className="iframe-div">
        {/* <iframe title="htFrame" src= {`https://iipl.retool.com/embedded/public/a75b2213-6ee5-405e-82c6-faff9ab1c4a0`}
        className="iframe-style"></iframe> */}
        <iframe src= {`https://iiplwork.retool.com/embedded/public/20524a71-05d9-4235-8633-477885726388`}
        className="iframe-style"></iframe>
    </div>
  )
};

export default FlipkartStockSync;
